
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.337 4.667a3.333 3.333 0 11-6.667 0 3.333 3.333 0 016.667 0zm-1.334 0a2 2 0 10-4 0 2 2 0 004 0zm-8.666 8.666c0-2.828 1.557-4 3.84-3.998.015 0-.498.55-.498 1.375 0 0-2.01.036-2.01 2.623h3.853l1.363 1.334H2.67c-1.47 0-1.333-1.334-1.333-1.334zm12 0c0-.832-.198-1.47-.592-1.914l1.008-1c.6.667.906 1.638.917 2.914 0 .889-.445 1.334-1.333 1.334H9.49l1.34-1.334h2.506zm.196-6.471a.667.667 0 11.942.943l-5.333 5.333a.667.667 0 01-.943 0l-2-2a.667.667 0 01.942-.943l1.53 1.529 4.862-4.862z","fill":"#668BFF"}})])
          )
        }
      }
    